import { render, staticRenderFns } from "./VMetabaseReports.vue?vue&type=template&id=a3162eea&"
import script from "./VMetabaseReports.vue?vue&type=script&lang=js&"
export * from "./VMetabaseReports.vue?vue&type=script&lang=js&"
import style0 from "./VMetabaseReports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports